import sharedConfig from '../config'
import { createService } from './create'

export * from './error'
// 基础请求
export const baseHttp = createService({ baseURL: sharedConfig.httpBaseUrl })
// 发布请求
export const publishHttp = createService({ baseURL: sharedConfig.httpPublishUrl })
